import React, { useState, useEffect } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { showCreateSiteModal, setAction } from 'Manage/actions'
import { ACTION_UPDATE, ACTION_CREATE } from 'components/CreateUpdateSiteModal/interface'
import DEEP_LINK from 'utils/deepLinks'

import './DomainExistsModal.css'

const DomainExistsModal = ({ show, onHide, existingSite }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const [modalShow, setModalShow] = useState(false)
  const [siteData, setSiteData] = useState(null)

  const openModal = (site) => {
    setSiteData(site)
    setModalShow(true)
  }

  useEffect(() => {
    const handleSiteData = () => {
      const siteData = localStorage.getItem('domainExistsSite')
      if (siteData) {
        try {
          const site = JSON.parse(siteData)
          openModal(site)
          localStorage.removeItem('domainExistsSite')
        } catch (error) {
          console.error('Error parsing site data:', error)
          history.replace({ pathname: '/manage' })
        }
      } else {
        history.replace({ pathname: '/manage' })
      }
    }

    if (location.pathname === DEEP_LINK.DOMAIN_EXIST) {
      handleSiteData()
    }

    window.addEventListener('domainExists', handleSiteData)
    return () => window.removeEventListener('domainExists', handleSiteData)
  }, [location.pathname, history])

  const closeModal = () => {
    if (modalShow) {
      setModalShow(false)
      setSiteData(null)
    } else {
      onHide()
    }
  }

  const handleUpdateProject = () => {
    const site = siteData || existingSite
    if (!site) return

    closeModal()
    dispatch(setAction(ACTION_UPDATE))
    dispatch(showCreateSiteModal(true, { ...site, domain: site.subdomain }, ACTION_UPDATE))
    setTimeout(() => history.push('/manage/update'), 100)
  }

  const handleCancel = () => {
    localStorage.setItem('cancelPresignedUpload', 'true')
    window.cancelPresignedUpload = true
    closeModal()
    dispatch(showCreateSiteModal(true, null, ACTION_CREATE))
    history.push('/manage/upload')
  }

  const isVisible = modalShow || show
  const currentSite = siteData || existingSite

  if (!isVisible || !currentSite) {
    return null
  }

  return (
    <Modal show={isVisible} onHide={handleCancel} centered>
      <Modal.Body className="p-4">
        <div className="text-center mb-4">
          <img className="domain-exists-icon" height={50} src="/assets/icons/warning_black.svg" alt="Warning" />
          <h4 className="mt-3 mb-3">Link Name Already Exists</h4>
          <p className="text-muted">
            You already have a project with this link name. Do you want to update that project?
          </p>
        </div>
        <div className="d-flex gap-2">
          <Button className="flex-fill cancel-button" variant="outline-secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button className="flex-fill" onClick={handleUpdateProject}>
            Update project
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default DomainExistsModal
